import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateInitiationWidgetLiveMutationVariables = Types.Exact<{
  input: Types.UpdateInitiationWidgetLiveInput;
}>;


export type UpdateInitiationWidgetLiveMutation = { __typename?: 'RootMutationType', updateInitiationWidgetLive?: { __typename?: 'InitiationSettingResult', initiationSetting?: { __typename?: 'InitiationSetting', id: string, widgetLive: boolean } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const UpdateInitiationWidgetLiveDocument = gql`
    mutation updateInitiationWidgetLive($input: UpdateInitiationWidgetLiveInput!) {
  updateInitiationWidgetLive(input: $input) {
    initiationSetting {
      id
      widgetLive
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type UpdateInitiationWidgetLiveMutationFn = Apollo.MutationFunction<UpdateInitiationWidgetLiveMutation, UpdateInitiationWidgetLiveMutationVariables>;

/**
 * __useUpdateInitiationWidgetLiveMutation__
 *
 * To run a mutation, you first call `useUpdateInitiationWidgetLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInitiationWidgetLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInitiationWidgetLiveMutation, { data, loading, error }] = useUpdateInitiationWidgetLiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInitiationWidgetLiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInitiationWidgetLiveMutation, UpdateInitiationWidgetLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInitiationWidgetLiveMutation, UpdateInitiationWidgetLiveMutationVariables>(UpdateInitiationWidgetLiveDocument, options);
      }
export type UpdateInitiationWidgetLiveMutationHookResult = ReturnType<typeof useUpdateInitiationWidgetLiveMutation>;
export type UpdateInitiationWidgetLiveMutationResult = Apollo.MutationResult<UpdateInitiationWidgetLiveMutation>;
export type UpdateInitiationWidgetLiveMutationOptions = Apollo.BaseMutationOptions<UpdateInitiationWidgetLiveMutation, UpdateInitiationWidgetLiveMutationVariables>;